import {
  FriendsResponse,
  LeaguesResponse,
  SettingsHashResponse,
  SettingsResponse,
  SyncReponse,
  TapResponse,
} from '@/types/api';

import { ServiceBase } from '../base';
import settings from './json/settings.json';
import sync from './json/sync.json';

class ServiceMock extends ServiceBase {
  async auth() {
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }

  async sync(): Promise<SyncReponse> {
    return sync as SyncReponse;
  }

  async getSettings() {
    return settings as SettingsResponse;
  }

  async getSettingsHash(): Promise<SettingsHashResponse> {
    return {
      hash: '02a93b9f4bdbb93516e0e41ccd5e88f9425e4dd3833361921438ee749d06db95',
    };
  }

  async getFriends(): Promise<FriendsResponse> {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return {
      friends: [
        {
          id: 1,
          username: 'name 1',
          name: 'name 1',
          level: 1,
          balance: 1,
          xp: 1,
          keys: 1,
          active: true,
        },
        {
          id: 2,
          username: 'name 2',
          name: 'name 2',
          level: 2,
          balance: 2,
          xp: 2,
          keys: 2,
          active: false,
        },
      ],
      has_more: false,
      ok: true,
      total_count: 2,
    };
  }

  async tap(): Promise<TapResponse> {
    const { player } = sync as SyncReponse;

    return {
      ok: true,
      balance: player.balance,
      energy: player.energy,
    };
  }

  async leagues(league: number): Promise<LeaguesResponse> {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    return {
      league: {
        name: 'league ' + league,
        number: league,
        require_badges: (league + 1) * 100,
      },
      top_players: [
        {
          id: 2,
          name: 'name 1',
          xp: 111111,
          balance: 11111111,
          level: 4,
        },
        {
          id: 3,
          name: 'name 2',
          xp: 22222,
          balance: 22222222,
          level: 4,
        },
        {
          id: 3,
          name: 'name 3',
          xp: 33333,
          balance: 3333333,
          level: 5,
        },
        {
          id: 4,
          name: 'name 4',
          xp: 44444,
          balance: 4444444,
          level: 2,
        },
        {
          id: 5,
          name: 'name 5',
          xp: 555555,
          balance: 555555,
          level: 4,
        },
      ],
      player: {
        id: 1234567890,
        name: '@Aboba',
        rank: 1,
        xp: 1000,
        balance: 777,
        level: 7,
      },
    };
  }
}

export default ServiceMock;
